export const WORKPLACE_PHYSICIAN = "WORKPLACE_PHYSICIAN";

export const emptyForm = {
  documentType: "",
  tcNo: "",
  firstName: "",
  lastName: "",
  branch: "",
  medulaPassword: "",
  plate: "",
  cardPin: "",
  clearMedulaPassword: false,
  clearCardPin: false,
};

const trimmed = (value) => (typeof value === "string" ? value.trim() : value);

const emptyToNull = (value) => {
  const text = trimmed(value);
  return text ? text : null;
};

function toBase64(text) {
  const bytes = new TextEncoder().encode(text);
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
}

export function encodeCardPin(cardPin) {
  const text = trimmed(cardPin);
  return text ? toBase64(text) : null;
}

export const isPhysician = (documentType) =>
  documentType === WORKPLACE_PHYSICIAN;

function secretValue(typed, clear, encode) {
  const text = trimmed(typed);
  if (text) {
    return encode ? toBase64(text) : text;
  }
  return clear ? "" : null;
}

const keepsSecret = (typed, clear, alreadyDefined) =>
  Boolean(trimmed(typed)) || (Boolean(alreadyDefined) && !clear);

export function validateForm(form, row) {
  const isEdit = Boolean(row);
  const errors = {};
  const required = "Bu alan boş bırakılamaz.";

  if (!isEdit) {
    if (!trimmed(form.documentType)) {
      errors.documentType = required;
    }
    const tcNo = trimmed(form.tcNo);
    if (!tcNo) {
      errors.tcNo = required;
    } else if (!/^[0-9]{11}$/.test(tcNo)) {
      errors.tcNo = "TC No 11 haneli olmalıdır.";
    }
  }
  if (!trimmed(form.firstName)) {
    errors.firstName = required;
  }
  if (!trimmed(form.lastName)) {
    errors.lastName = required;
  }

  if (isPhysician(form.documentType)) {
    if (!trimmed(form.plate)) {
      errors.plate = required;
    }
    if (
      !keepsSecret(
        form.medulaPassword,
        form.clearMedulaPassword,
        row && row.medulaPasswordDefined
      )
    ) {
      errors.medulaPassword = required;
    }
  }

  return errors;
}

export function buildCreatePayload(form) {
  return {
    documentType: trimmed(form.documentType),
    tcNo: trimmed(form.tcNo),
    firstName: trimmed(form.firstName),
    lastName: trimmed(form.lastName),
    branch: emptyToNull(form.branch),
    medulaPassword: emptyToNull(form.medulaPassword),
    plate: emptyToNull(form.plate),
    cardPin: encodeCardPin(form.cardPin),
  };
}

export function buildUpdatePayload(form) {
  return {
    firstName: trimmed(form.firstName),
    lastName: trimmed(form.lastName),
    branch: trimmed(form.branch),
    plate: trimmed(form.plate),
    medulaPassword: secretValue(
      form.medulaPassword,
      form.clearMedulaPassword,
      false
    ),
    cardPin: secretValue(form.cardPin, form.clearCardPin, true),
  };
}

export function toFormValues(row) {
  return {
    ...emptyForm,
    documentType: row.documentType || "",
    tcNo: row.tcNo || "",
    firstName: row.firstName || "",
    lastName: row.lastName || "",
    branch: row.branch || "",
    plate: row.plate || "",
  };
}
